import HttpClient from './HttpClient';
import AppConfig from '../../../Configs/AppConfig';
import { getToken } from '../Token/GetToken';

const headers: Headers = new Headers({
  Accept: 'application/vnd.api+json',
  Authorization: `Bearer ${getToken()}`,
});

export default new HttpClient(headers, AppConfig.API_BASE_URL);
